// Timezone detection and cookie setting for Rails application
// Compatible with Turbo Rails navigation

document.addEventListener('DOMContentLoaded', function() {
  'use strict';

  // Function to detect user's timezone
  function detectTimezone() {
    try {
      // Use Intl.DateTimeFormat to get the user's timezone
      return Intl.DateTimeFormat().resolvedOptions().timeZone;
    } catch (error) {
      console.warn('Could not detect timezone using Intl API, falling back to offset detection');
      
      // Fallback: Use timezone offset to guess timezone
      const offset = new Date().getTimezoneOffset();
      const hours = Math.floor(Math.abs(offset) / 60);
      const minutes = Math.abs(offset) % 60;
      const sign = offset > 0 ? '-' : '+';
      
      // This is a basic fallback - in production you might want a more comprehensive mapping
      const offsetString = `UTC${sign}${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
      return offsetString;
    }
  }

  // Function to set timezone cookie
  function setTimezoneCookie() {
    const timezone = detectTimezone();
    const cookieName = 'user_timezone';
    const cookieValue = encodeURIComponent(timezone);
    const expires = new Date();
    expires.setFullYear(expires.getFullYear() + 1); // Cookie expires in 1 year
    
    // Set the cookie with proper attributes
    document.cookie = `${cookieName}=${cookieValue}; expires=${expires.toUTCString()}; path=/; SameSite=Lax`;
    
    console.log(`Timezone detected and set: ${timezone}`);
    return timezone;
  }

  // Function to check if timezone cookie already exists
  function getTimezoneCookie() {
    const cookieName = 'user_timezone';
    const cookies = document.cookie.split(';');
    
    for (let cookie of cookies) {
      const trimmedCookie = cookie.trim();
      if (trimmedCookie.startsWith(`${cookieName}=`)) {
        return decodeURIComponent(trimmedCookie.substring(cookieName.length + 1));
      }
    }
    return null;
  }

  // Function to initialize timezone detection
  function initializeTimezone() {
    const existingTimezone = getTimezoneCookie();
    const currentTimezone = detectTimezone();
    
    // Set/update cookie if timezone is different or doesn't exist
    if (!existingTimezone || existingTimezone !== currentTimezone) {
      setTimezoneCookie();
    }
  }

  // Initialize timezone detection
  initializeTimezone();

  // Export functions for potential external use
  window.TimezoneDetector = {
    detect: detectTimezone,
    setCookie: setTimezoneCookie,
    getCookie: getTimezoneCookie,
    initialize: initializeTimezone
  };

  // Also handle page visibility changes (when user returns to tab)
  document.addEventListener('visibilitychange', function() {
    if (!document.hidden) {
      // Check timezone when page becomes visible again
      initializeTimezone();
    }
  });

  // Handle Turbo navigation events to reinitialize timezone detection
  document.addEventListener('turbo:load', function() {
    initializeTimezone();
  });

});